(function() {

  const ERROR_MESSAGE = '【カートに一緒に入れることができない商品が含まれています】\n「店頭受取商品（フルーツタブレット）」と「通常配送商品」は同時にご購入いただけません。';

  function showError(message) {
    const existing = document.getElementById('cart-restriction-error');
    if (existing) existing.remove();

    const el = document.createElement('div');
    el.id = 'cart-restriction-error';
    el.style.cssText = [
      'background:#f8d7da',
      'color:#721c24',
      'border:1px solid #f5c6cb',
      'padding:12px 16px',
      'margin:10px 0',
      'border-radius:4px',
      'font-size:14px',
      'z-index:99999',
      'position:relative',
      'white-space:pre-line'
    ].join(';');
    el.textContent = message;

    const targets = [
      document.querySelector('.ProductForm'),
      document.querySelector('form.ProductForm'),
      document.querySelector('form[action*="/cart/add"]'),
      document.querySelector('main'),
      document.body
    ];
    const target = targets.find(t => t !== null);
    if (target) target.prepend(el);

    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function getVariantInfo(variantId) {
    const res = await fetch(`/variants/${variantId}.js`);
    return res.json();
  }

  async function checkRestriction(variantId) {
    const [variant, cart] = await Promise.all([
      getVariantInfo(variantId),
      getCart()
    ]);

    const addingRequiresShipping = variant.requires_shipping;
    const items = cart.items || [];

    const cartHasNonShipping = items.some(i => i.requires_shipping === false);
    const cartHasShipping = items.some(i => i.requires_shipping === true);

    if (addingRequiresShipping === false && cartHasShipping) return ERROR_MESSAGE;
    if (addingRequiresShipping === true && cartHasNonShipping) return ERROR_MESSAGE;

    return null;
  }

  async function extractVariantId(body) {
    let variantId = null;
    try {
      if (body instanceof FormData) {
        for (let [key, value] of body.entries()) {
          if (key === 'id') { variantId = value; break; }
          const match = key.match(/updates\[(\d+)\]/);
          if (match) { variantId = match[1]; break; }
        }
      } else if (typeof body === 'string') {
        try {
          const json = JSON.parse(body);
          variantId = json.id || (json.items && json.items[0]?.id);
          if (!variantId && json.updates) variantId = Object.keys(json.updates)[0];
        } catch(e) {
          const params = new URLSearchParams(body);
          variantId = params.get('id');
          if (!variantId) {
            for (let [key] of params.entries()) {
              const match = key.match(/updates\[(\d+)\]/);
              if (match) { variantId = match[1]; break; }
            }
          }
        }
      } else if (body instanceof URLSearchParams) {
        variantId = body.get('id');
      }
    } catch(e) {}
    return variantId;
  }

  // フォーム送信インターセプト
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    if (form.method.toLowerCase() !== 'post') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const productIdInput = form.querySelector('[name="id"]');
    if (!productIdInput) { form.submit(); return; }

    const variantId = productIdInput.value;

    checkRestriction(variantId)
      .then(errorMessage => {
        if (errorMessage) {
          showError(errorMessage);
        } else {
          const formData = new FormData(form);
          return fetch('/cart/add.js', { method: 'POST', body: formData })
            .then(res => { if (res.ok) window.location.href = '/cart'; });
        }
      })
      .catch(err => { form.submit(); });
  }, true);

  // fetchインターセプト
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const isCartAdd = url.includes('/cart/add');
    const isCartUpdate = url.includes('/cart/update.js');

    if (!isCartAdd && !isCartUpdate) {
      return originalFetch.apply(this, args);
    }

    try {
      const body = args[1]?.body;
      const variantId = await extractVariantId(body);

      if (variantId) {
        const errorMessage = await checkRestriction(variantId);
        if (errorMessage) {
          showError(errorMessage);
          return new Response(
            JSON.stringify({ status: 422, description: errorMessage, message: errorMessage }),
            { status: 422, headers: { 'Content-Type': 'application/json' } }
          );
        }
      }
    } catch(err) {}

    return originalFetch.apply(this, args);
  };

  // XHRインターセプト
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._cartUrl = url;
    return originalOpen.apply(this, [method, url, ...rest]);
  };

  XMLHttpRequest.prototype.send = function(body) {
    const isCartAdd = this._cartUrl && this._cartUrl.includes('/cart/add');
    const isCartUpdate = this._cartUrl && this._cartUrl.includes('/cart/update.js');

    if (isCartAdd || isCartUpdate) {
      const xhr = this;
      extractVariantId(body).then(variantId => {
        if (!variantId) { originalSend.apply(xhr, [body]); return; }
        return checkRestriction(variantId)
          .then(errorMessage => {
            if (errorMessage) {
              showError(errorMessage);
              xhr.abort();
            } else {
              originalSend.apply(xhr, [body]);
            }
          });
      }).catch(() => originalSend.apply(xhr, [body]));
      return;
    }
    return originalSend.apply(this, [body]);
  };

})();
